import styled from "styled-components";

const UIHr = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: ${props => `1px solid ${props.theme.colors.paleskyLightest}`};
  margin: 1em 0;
  padding: 0;
`;

UIHr.displayName = "UIHr";

export default UIHr;